import React from 'react';
import Spinner from '../../Spinner';

interface LoadingRowProps {
  colSpan: number;
}

const LoadingRow: React.FC<LoadingRowProps> = ({ colSpan }) => {
  return (
    <>
      {Array.from({ length: 5 }, (_, i) => (
        <tr key={i} style={{ borderBottom: '1px solid var(--line)' }}>
          <td colSpan={colSpan} style={{ padding: '17px 22px' }}>
            <div
              style={{
                height: '14px',
                borderRadius: '4px',
                backgroundColor: 'var(--surf2)',
                width: `${85 - i * 8}%`,
                opacity: 0.7,
              }}
            />
          </td>
        </tr>
      ))}
    </>
  );
};

export default LoadingRow;
